<template>
    <v-btn small color="green white--text text-lowercase" v-if="!following" :loading="loading" :disabled="loading" 
    @click.prevent.stop="$emit('followAction')">follow
        <template v-slot:loader>
            <v-progress-circular indeterminate color="grey lighten-5" size="20"></v-progress-circular>
        </template>
    </v-btn>
    <v-btn small color="grey lighten-1 text--grey text-lowercase" v-else :loading="loading" :disabled="loading"
    @click.prevent.stop="$emit('unFollowAction')">unfollow
        <template v-slot:loader>
            <v-progress-circular indeterminate color="grey lighten-5" size="20"></v-progress-circular>
        </template>
    </v-btn>
</template>
<script>
	export default {
		props: {
			following: Boolean,
			loading: Boolean
		}
	}
</script>